import styled from 'styled-components';

export const DatePickerWrapper = styled.div`
  padding: 0 0 12px;
`;
